export default __webpack_public_path__ + "static/aerial-b5047454b29eda7dd4dd08286469c218.jpeg";